import useSwal from "@common-hooks/useSwal"
import { useAuth } from "../../../../AppContext"
import React from "react"
import { ICandidatDocumentModel, IConsultantDocumentModel } from "@common-models/*"
import { toast } from "react-toastify"
import { addCandidatDocument, deleteCandidatDocument, replaceCandidatDocument } from "./_requests"
import { AxiosError } from "axios"
import { CONST_CIVILITE_MME } from "@common-constants/*"

export const useCandidatDocumentActions = (candidat_ID: number) => {
     const { swal } = useSwal()
     const { currentUser } = useAuth()

     function add(e: React.ChangeEvent<HTMLInputElement>, type: string, callback: (val: IConsultantDocumentModel) => void = () => {}) {
          const fileBinary = e.target.files![0]

          if (fileBinary) {
               e.target.disabled = true
               toast.info(`Envoi du document en cours ...`, { autoClose: false })

               addCandidatDocument(candidat_ID, type, fileBinary)
                    .then(r => {
                         callback(r.data)
                         toast.dismiss()
                         toast.success("Le document a bien ajouté.")
                    })
                    .catch((e: AxiosError) => {
                         toast.dismiss()
                         toast.error(e?.response?.data?.detail, { autoClose: false })
                    })
                    .finally(() => {
                         e.target.value = ""
                         e.target.disabled = false
                    })
          }
     }

     function flagAsDeleted(id: number, callback: () => void = () => {}) {
          swal.fire({
               icon: "warning",
               text: `Êtes-vous sûr${currentUser?.civilite === CONST_CIVILITE_MME ? "e" : ""} de vouloir supprimer le document?`,
               showCancelButton: true,
               confirmButtonText: "Oui",
               cancelButtonText: "Annuler",
               focusConfirm: true,
               showLoaderOnConfirm: true,
               preConfirm: () => {
                    return deleteCandidatDocument(id)
                         .then(() => {
                              callback()
                              toast.success("Le document a bien été supprimé.")
                         })
                         .catch(e => {
                              toast.error(e?.response?.data?.detail, { autoClose: false })
                         })
               },
               allowOutsideClick: () => !swal.isLoading(),
          }).then()
     }

     function replace(e: React.ChangeEvent<HTMLInputElement>, id: number, callback: (val: ICandidatDocumentModel) => void = () => {}) {
          const fileBinary = e.target.files![0]

          if (fileBinary) {
               e.target.disabled = true
               toast.info("Remplacement du document en cours ...", { autoClose: false })

               replaceCandidatDocument(id, fileBinary)
                    .then(r => {
                         callback(r.data)
                         toast.dismiss()
                         toast.success("Le document a bien été remplacé.")
                    })
                    .catch(e => {
                         toast.dismiss()
                         toast.error(e?.response?.data?.detail, { autoClose: false })
                    })
                    .finally(() => {
                         e.target.value = ""
                         e.target.disabled = false
                    })
          }
     }

     return { add, flagAsDeleted, replace }
}
